import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Clock, Users, Heart, Trash2, Star } from 'lucide-react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const RecipeListItem = ({ recipe, onRecipeUpdate }) => {
  const navigate = useNavigate();
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async (e) => {
    e.stopPropagation();
    
    if (!confirm('Tem certeza que deseja deletar esta receita?')) {
      return;
    }

    try {
      setDeleting(true);
      await axios.delete(`${API}/recipes/${recipe.id}`);
      toast.success('Receita deletada!');
      if (onRecipeUpdate) onRecipeUpdate();
    } catch (error) {
      console.error('Error deleting recipe:', error);
      toast.error('Erro ao deletar receita');
      setDeleting(false);
    }
  };

  return (
    <Card 
      className="flex gap-3 p-3 hover:shadow-lg transition-all cursor-pointer border border-gray-200 bg-white"
      onClick={() => navigate(`/recipe/${recipe.id}`)}
    >
      {/* Image */}
      <div className="flex-shrink-0">
        <img
          src={recipe.image_url || '/default-recipe.jpg'}
          alt={recipe.title}
          className="w-20 h-20 sm:w-28 sm:h-28 object-cover rounded-lg"
        />
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0 flex flex-col">
        <div className="flex items-start justify-between gap-2 mb-1">
          <div className="flex-1 min-w-0">
            <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-1 truncate">
              {recipe.title}
            </h3>
            <Badge className="bg-orange-100 text-orange-700 text-xs">
              {recipe.category}
            </Badge>
          </div>
          
          {recipe.user_id && (
            <Button
              variant="ghost"
              size="icon"
              className="flex-shrink-0 h-8 w-8"
              onClick={handleDelete}
              disabled={deleting}
              className="text-red-500 hover:text-red-700 hover:bg-red-50 flex-shrink-0"
            >
              <Trash2 className="w-4 h-4" />
            </Button>
          )}
        </div>

        <p className="text-xs sm:text-sm text-gray-600 mb-2 line-clamp-2">
          {recipe.description}
        </p>

        <div className="flex flex-wrap items-center gap-2 sm:gap-4 text-xs sm:text-sm text-gray-600">
          <div className="flex items-center gap-1">
            <Clock className="w-4 h-4" />
            <span>{recipe.prep_time + recipe.cook_time} min</span>
          </div>
          
          <div className="flex items-center gap-1">
            <Users className="w-4 h-4" />
            <span>{recipe.servings} porções</span>
          </div>

          {recipe.nutrition?.calories && (
            <div className="flex items-center gap-1">
              <span className="font-medium">🔥</span>
              <span>{recipe.nutrition.calories} kcal</span>
            </div>
          )}

          {recipe.rating && (
            <div className="flex items-center gap-1">
              <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" />
              <span>{recipe.rating.toFixed(1)}</span>
            </div>
          )}
        </div>
      </div>
    </Card>
  );
};

export default RecipeListItem;
